import {
    getPlaceByUid,
    GetPlaceByUidApiResponseSchema,
} from './get-place-by-uid';

export {
    GetPlaceByUidApiResponseSchema,
};

export const PlacePageActions = {
    getPlaceByUid,
};
